import logger from './logger';
/**
 * URL utility functions for dynamic host detection
 */

/**
 * Get the base URL for the current environment
 * Uses REACT_APP_FRONTEND_URL environment variable or falls back to window.location.origin
 * @returns {string} The base URL
 */
export const getBaseUrl = () => {
  // Use environment variable if available, otherwise use current origin
  return process.env.REACT_APP_FRONTEND_URL || window.location.origin;
};

/**
 * Generate a table URL for a specific shop and table
 * @param {string} shopSlug - The shop slug
 * @param {number} tableNumber - The table number
 * @returns {string} The complete table URL
 */
export const generateTableUrl = (shopSlug, tableNumber) => {
  const baseUrl = getBaseUrl();
  return `${baseUrl}/shop/${shopSlug}/table/${tableNumber}`;
};

/**
 * Generate a public shop URL
 * @param {string} shopSlug - The shop slug
 * @returns {string} The complete shop URL
 */
export const generateShopUrl = (shopSlug) => {
  const baseUrl = getBaseUrl();
  return `${baseUrl}/shop/${shopSlug}`;
};

/**
 * Copy text to clipboard with error handling
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} Success status
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // Fallback for older browsers
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackError) {
  logger.error('Failed to copy to clipboard:', fallbackError);
      return false;
    }
  }
};

/**
 * Download a file from blob data
 * @param {Blob} blob - The blob data
 * @param {string} filename - The filename for the download
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
